import { components, DropdownIndicatorProps, GroupBase } from "react-select";

import { ReactComponent as ChevronDown } from "assets/images/iconsV2/chevron-down.svg";

import type { SelectOption } from "../types";

export default function SelectDropdownIndicator(
  props: DropdownIndicatorProps<SelectOption, false, GroupBase<SelectOption>>,
) {
  return (
    <components.DropdownIndicator {...props}>
      <ChevronDown />
    </components.DropdownIndicator>
  );
}
